var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineBuyCrypto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.94 15.73a.751.751 0 0 1-.7-.69c-.22-2.79-2.49-5.05-5.27-5.27a.751.751 0 0 1-.69-.7 7.255 7.255 0 0 1 7.23-7.81c4 0 7.25 3.25 7.25 7.25s-3.26 7.24-7.26 7.24c-.18 0-.38-.01-.56-.02zm.7-1.48a5.755 5.755 0 0 0 5.61-5.75c0-3.17-2.58-5.75-5.75-5.75-3.12 0-5.67 2.5-5.75 5.61 2.98.53 5.37 2.91 5.89 5.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 15.5a7.255 7.255 0 0 1 7.81-7.23c3.53.28 6.39 3.14 6.66 6.65.01.2.02.4.02.58.01 4-3.24 7.25-7.24 7.25S1.25 19.5 1.25 15.5zm1.5 0c0 3.17 2.58 5.75 5.75 5.75a5.757 5.757 0 0 0 5.73-6.23c-.22-2.77-2.49-5.04-5.27-5.26-.14 0-.3-.01-.46-.01-3.17 0-5.75 2.58-5.75 5.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.84 18.36-.78-1.42-1.42-.78a.745.745 0 0 1-.39-.66c0-.28.15-.53.39-.66l1.42-.78.78-1.42c.26-.48 1.05-.48 1.32 0l.78 1.42 1.42.78c.24.13.39.38.39.66s-.15.53-.39.66l-1.42.78-.78 1.42c-.13.24-.39.39-.66.39s-.53-.15-.66-.39zm.13-2.63c.13.07.23.17.3.3l.23.41.23-.41c.07-.13.17-.23.3-.3l.41-.23-.41-.23a.723.723 0 0 1-.3-.3l-.23-.41-.23.41c-.07.13-.17.23-.3.3l-.41.23.41.23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBuyCrypto);
export default __webpack_public_path__ + "static/media/vuesax-outline-buy-crypto.bd7b9c47e317a0d063df124b2fa92287.svg";
export { ForwardRef as ReactComponent };